import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const API_BASE = "https://eluvent.com/api";
const ADMIN_PIN = "Eluvent2026";
const PER_PAGE = 20;

const Admin = () => {
  const [authenticated, setAuthenticated] = useState(false);
  const [pinInput, setPinInput] = useState("");
  const [pinError, setPinError] = useState(false);
  const [stats, setStats] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [leads, setLeads] = useState([]);
  const [activeTab, setActiveTab] = useState("sessions");
  const [loading, setLoading] = useState(true);
  const [sessionsPage, setSessionsPage] = useState(1);
  const [leadsPage, setLeadsPage] = useState(1);
  const [sessionsTotal, setSessionsTotal] = useState(0);
  const [leadsTotal, setLeadsTotal] = useState(0);

  // New: system health state
  const [health, setHealth] = useState(null);
  const [healthLoading, setHealthLoading] = useState(false);
  const [healthError, setHealthError] = useState(null);

  useEffect(() => {
    if (sessionStorage.getItem("eluvent_admin_auth") === "true") setAuthenticated(true);
  }, []);

  useEffect(() => {
    if (!authenticated) return;
    axios.get(API_BASE + "/admin/stats").then(r => setStats(r.data)).catch(console.error);
  }, [authenticated]);

  useEffect(() => {
    if (!authenticated) return;
    setLoading(true);
    const url = activeTab === "sessions"
      ? API_BASE + "/admin/sessions?page=" + sessionsPage + "&per_page=" + PER_PAGE
      : activeTab === "leads"
      ? API_BASE + "/admin/leads-paginated?page=" + leadsPage + "&per_page=" + PER_PAGE
      : null;
    if (!url) { setLoading(false); return; }
    axios.get(url).then(r => {
      if (activeTab === "sessions") { setSessions(r.data.sessions); setSessionsTotal(r.data.total); }
      else { setLeads(r.data.leads); setLeadsTotal(r.data.total); }
      setLoading(false);
    }).catch(e => { console.error(e); setLoading(false); });
  }, [authenticated, activeTab, sessionsPage, leadsPage]);

  // Fetch health data when Health tab is selected
  useEffect(() => {
    if (!authenticated || activeTab !== "health") return;
    setHealthLoading(true);
    setHealthError(null);
    axios.get(API_BASE + "/admin/health")
      .then(r => setHealth(r.data))
      .catch(() => setHealthError("Failed to fetch system health."))
      .finally(() => setHealthLoading(false));
  }, [authenticated, activeTab]);

  const handlePinSubmit = (e) => {
    e.preventDefault();
    if (pinInput === ADMIN_PIN) { setAuthenticated(true); sessionStorage.setItem("eluvent_admin_auth", "true"); setPinError(false); }
    else { setPinError(true); setPinInput(""); }
  };

  const totalSessionsPages = Math.ceil(sessionsTotal / PER_PAGE) || 1;
  const totalLeadsPages = Math.ceil(leadsTotal / PER_PAGE) || 1;

  const getHealthColor = (value) => (value === "active" || value === "ok" || value === "online") ? "#10b981" : "#ef4444";

  if (!authenticated) return (
    <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", background: "linear-gradient(135deg, #1e3a5f, #2c5282)", fontFamily: "Arial" }}>
      <div style={{ background: "white", padding: 40, borderRadius: 16, textAlign: "center", boxShadow: "0 20px 40px rgba(0,0,0,0.3)", maxWidth: 400, width: "90%" }}>
        <h2>Eluvent Admin</h2><p style={{ color: "#666", marginBottom: 24 }}>Enter access PIN</p>
        <form onSubmit={handlePinSubmit}>
          <input type="password" value={pinInput} onChange={e => setPinInput(e.target.value)} placeholder="Enter PIN" autoFocus style={{ width: "100%", padding: 14, borderRadius: 10, border: pinError ? "2px solid #ef4444" : "2px solid #ddd", fontSize: 18, textAlign: "center", letterSpacing: 8, boxSizing: "border-box", marginBottom: 16 }} />
          {pinError && <p style={{ color: "#ef4444", fontSize: 13 }}>Incorrect PIN</p>}
          <button type="submit" style={{ width: "100%", padding: 14, background: "linear-gradient(135deg, #2c5282, #1e3a5f)", color: "white", border: "none", borderRadius: 10, fontSize: 16, fontWeight: "bold", cursor: "pointer" }}>Unlock Dashboard</button>
        </form>
      </div>
    </div>
  );

  const SC = ({ l, v, c, e }) => (<div style={{ background: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", borderLeft: "4px solid " + c }}><div style={{ fontSize: 24 }}>{e}</div><div style={{ fontSize: 28, fontWeight: "bold", color: c, marginTop: 8 }}>{v}</div><div style={{ fontSize: 13, color: "#666", marginTop: 4 }}>{l}</div></div>);
  const tb = (a) => ({ padding: "10px 20px", background: a ? "#2c5282" : "white", color: a ? "white" : "#333", border: "1px solid #ddd", borderRadius: 8, cursor: "pointer", fontWeight: "bold", fontSize: 14 });
  const Pg = ({ p, t, f }) => (<div style={{ display: "flex", justifyContent: "center", gap: 8, marginTop: 16, alignItems: "center" }}><button onClick={() => f(p - 1)} disabled={p <= 1} style={{ padding: "6px 14px", borderRadius: 6, border: "1px solid #ddd", background: p <= 1 ? "#f0f0f0" : "white", cursor: p <= 1 ? "default" : "pointer", fontSize: 13 }}>Previous</button><span style={{ fontSize: 13, color: "#666" }}>Page {p} of {t}</span><button onClick={() => f(p + 1)} disabled={p >= t} style={{ padding: "6px 14px", borderRadius: 6, border: "1px solid #ddd", background: p >= t ? "#f0f0f0" : "white", cursor: p >= t ? "default" : "pointer", fontSize: 13 }}>Next</button></div>);

  return (
    <div style={{ maxWidth: 1200, margin: "0 auto", padding: 20, fontFamily: "Arial", background: "#f5f7fa", minHeight: "100vh" }}>
      <div style={{ background: "linear-gradient(135deg, #1e3a5f, #2c5282)", padding: "20px 30px", borderRadius: 16, marginBottom: 24, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <div><h1 style={{ color: "white", margin: 0 }}>Eluvent Admin</h1><p style={{ color: "#caf0f8", margin: 5, fontSize: 13 }}>Real-time activity dashboard</p></div>
        <div style={{ display: "flex", gap: 10 }}>
          <Link to="/" style={{ color: "white", textDecoration: "none", fontSize: 14, background: "rgba(255,255,255,0.15)", padding: "8px 16px", borderRadius: 20 }}>Back to Tutor</Link>
          <button onClick={() => { sessionStorage.removeItem("eluvent_admin_auth"); setAuthenticated(false); }} style={{ color: "white", background: "rgba(239,68,68,0.3)", border: "none", padding: "8px 16px", borderRadius: 20, cursor: "pointer", fontSize: 14 }}>Lock</button>
        </div>
      </div>
      {stats && (<div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 14, marginBottom: 24 }}>
        <SC l="Sessions" v={stats.total_sessions} c="#667eea" e="S" /><SC l="Questions" v={stats.total_questions} c="#10b981" e="Q" /><SC l="Leads" v={stats.total_leads} c="#f59e0b" e="L" /><SC l="Contacts" v={stats.total_contacts} c="#8b5cf6" e="C" /><SC l="Pending" v={stats.pending_alerts} c="#ef4444" e="P" />
      </div>)}
      <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
        <button onClick={() => { setActiveTab("sessions"); setSessionsPage(1); }} style={tb(activeTab === "sessions")}>Sessions</button>
        <button onClick={() => { setActiveTab("leads"); setLeadsPage(1); }} style={tb(activeTab === "leads")}>Leads</button>
        <button onClick={() => setActiveTab("health")} style={tb(activeTab === "health")}>❤️ Health</button>
      </div>

      {activeTab === "health" ? (
        <div>
          {healthLoading ? <div style={{ textAlign: "center", padding: 40 }}>Loading health data...</div> : healthError ? <p style={{ textAlign: "center", color: "#ef4444" }}>{healthError}</p> : health && (
            <div style={{ background: "white", borderRadius: 12, padding: 20, boxShadow: "0 2px 8px rgba(0,0,0,0.05)" }}>
              <h3 style={{ margin: "0 0 16px", color: "#1e293b" }}>System Health</h3>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, fontSize: 14 }}>
                <div><strong>🤖 Gunicorn:</strong> <span style={{ color: getHealthColor(health.gunicorn) }}>{health.gunicorn}</span></div>
                <div><strong>🌐 Nginx:</strong> <span style={{ color: getHealthColor(health.nginx) }}>{health.nginx}</span></div>
                <div><strong>💾 Disk:</strong> {health.disk_used} used / {health.disk_avail} free ({health.disk_percent})</div>
                <div><strong>🧠 Memory:</strong> {health.mem_used} / {health.mem_total}</div>
                <div><strong>🔄 Swap:</strong> {health.swap_used} / {health.swap_total}</div>
                <div><strong>🔥 Firewall:</strong> <span style={{ color: getHealthColor(health.firewall) }}>{health.firewall}</span></div>
                <div style={{ gridColumn: "span 2" }}><strong>⏱️ Uptime:</strong> {health.uptime}</div>
              </div>
            </div>
          )}
        </div>
      ) : loading ? <div style={{ textAlign: "center", padding: 40 }}>Loading...</div> : (
        <div style={{ background: "white", borderRadius: 12, padding: 16, boxShadow: "0 2px 8px rgba(0,0,0,0.05)", overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            {activeTab === "sessions" ? (
              <><thead><tr><th>Session ID</th><th>Question</th><th>Reason</th><th>Status</th><th>Time</th></tr></thead>
              <tbody>{sessions.map((s, i) => (<tr key={i}><td style={{ fontFamily: "monospace", fontSize: 12 }}>{(s.session_id || "").substring(0, 20)}...</td><td>{s.question}</td><td>{s.reason}</td><td><span style={{ padding: "2px 10px", borderRadius: 12, fontSize: 12, background: s.status === "pending" ? "#fef3c7" : "#d1fae5", color: s.status === "pending" ? "#92400e" : "#065f46" }}>{s.status}</span></td><td style={{ fontSize: 12, color: "#666" }}>{new Date(s.created_at).toLocaleString()}</td></tr>))}</tbody></>
            ) : (
              <><thead><tr><th>Name</th><th>Email</th><th>Phone</th><th>Session ID</th><th>Time</th></tr></thead>
              <tbody>{leads.map((l, i) => (<tr key={i}><td><strong>{l.name}</strong></td><td>{l.email}</td><td>{l.phone}</td><td style={{ fontFamily: "monospace", fontSize: 12 }}>{(l.session_id || "").substring(0, 20)}...</td><td style={{ fontSize: 12, color: "#666" }}>{new Date(l.created_at).toLocaleString()}</td></tr>))}</tbody></>
            )}
          </table>
          {activeTab === "sessions" ? <Pg p={sessionsPage} t={totalSessionsPages} f={setSessionsPage} /> : <Pg p={leadsPage} t={totalLeadsPages} f={setLeadsPage} />}
        </div>
      )}
      <div style={{ textAlign: "center", marginTop: 24, color: "#999", fontSize: 12 }}>Auto-refreshes every 30s | Eluvent Admin v3.0</div>
    </div>
  );
};

export default Admin;